module.exports = __webpack_public_path__ + "img/rectangle-unchecked.0e742555.svg";